<template>
    <div class="my-2">
        <v-card>
            <submission-trackers-list-item-content v-if="!tracker.ad" :tracker="this.tracker" />
            <InFeedAdsense v-else
                data-ad-layout-key="-fb+5w+4e-db+86"
                data-ad-client="ca-pub-5150261809463519"
                data-ad-slot="7968081866"
            />
        </v-card>
    </div>
</template>

<script>
import SubmissionTrackersListItemContent from './SubmissionTrackersListItemContent';
export default {
  name: 'SubmissionTrackersListItem',

  components: {
      SubmissionTrackersListItemContent
  },

  props: {
    tracker: Object,
  },
};
</script>
